import { gql } from "@apollo/client";

/**
 * Fleet operators eligible for assignment on an unpermitted-vehicle citation
 * (AUT-5031/AUT-5032): accounts holding a permit attached to a rule of the
 * policy that generated the violation, valid at session time.
 */
export const GET_ASSIGNABLE_ENFORCEMENT_INTENT_OPERATORS = gql`
  query GetAssignableEnforcementIntentOperators($intentId: uuid!, $search: String) {
    assignable_enforcement_intent_operators(enforcement_intent_id: $intentId, search: $search) {
      accountId: account_id
      organizationName: organization_name
    }
  }
`;

export interface AssignableOperator {
  accountId: string;
  organizationName: string;
}

export interface GetAssignableEnforcementIntentOperatorsData {
  assignable_enforcement_intent_operators: AssignableOperator[];
}

export interface GetAssignableEnforcementIntentOperatorsVars {
  intentId: string;
  search?: string;
}

export default GET_ASSIGNABLE_ENFORCEMENT_INTENT_OPERATORS;
